import React, { forwardRef } from 'react';
import { INPUT_BASE } from './Input';

const Select = forwardRef(function Select({ invalid = false, className = '', children, ...rest }, ref) {
  const borderClass = invalid ? 'border-red-500 dark:border-red-400' : 'border-edge-strong';
  return (
    <select ref={ref} className={`${INPUT_BASE} ${borderClass} appearance-none bg-no-repeat cursor-pointer pe-9 mm-select-arrow ${className}`} {...rest}>
      {children}
    </select>
  );
});

export default Select;
